import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useCookies } from 'react-cookie';
import styled, { withTheme } from 'styled-components';

import { getColor, getImpersonation, stopImpersonation } from 'utils';
import { UserOutlined } from 'components/icons';

const Bar = styled('div')`
    position: sticky;
    top: 0;
    z-index: 300;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: center;
    gap: 0.5rem 0.75rem;
    padding: 0.5rem 1rem;
    font-size: 0.875rem;
    color: ${props => getColor(props, 'onAccent')};
    background-color: ${props => getColor(props, 'accent')};
    box-shadow: 0 0.1rem 0.25rem ${props => props.theme.hexToRgba(getColor(props, 'black'), 0.25)};

    svg { display: block; }
    svg path { fill: currentColor; }
`;

const Label = styled('span')`
    display: inline-flex;
    align-items: center;
    gap: 0.4rem;
`;

const ReturnButton = styled('button')`
    display: inline-flex;
    align-items: center;
    padding: 0.25rem 0.85rem;
    font-size: 0.8rem;
    font-weight: 600;
    cursor: pointer;
    border-radius: 1rem;
    transition: all 0.15s ease;
    color: ${props => getColor(props, 'onAccent')};
    border: 0.0625rem solid ${props => props.theme.hexToRgba(getColor(props, 'onAccent'), 0.55)};
    background-color: ${props => props.theme.hexToRgba(getColor(props, 'onAccent'), 0.14)};

    &:hover {
        color: ${props => getColor(props, 'accent')};
        background-color: ${props => getColor(props, 'onAccent')};
        border-color: ${props => getColor(props, 'onAccent')};
    }
`;

const ImpersonationBanner = withTheme(({ theme }) => {
    const [ , setCookie ] = useCookies([ 'userAuth' ]);
    const selectedTheme = useSelector(state => state.userData.userPreferences.theme);
    const [ info, setInfo ] = useState(getImpersonation());

    useEffect(() => {
        setInfo(getImpersonation());
    }, []);

    if (!info) return null;

    return (
        <Bar theme={theme} $selectedTheme={selectedTheme}>
            <Label>
                <UserOutlined width={16} height={16} color='currentColor' />
                You are logged in as&nbsp;<strong>{info.name}</strong>.
            </Label>
            <ReturnButton
                theme={theme}
                $selectedTheme={selectedTheme}
                onClick={() => stopImpersonation({ setCookie })}
            >
                Return to admin
            </ReturnButton>
        </Bar>
    );
});

export { ImpersonationBanner };
